import { render, staticRenderFns } from "./reactivo-categorizacion-reload-respuestas.vue?vue&type=template&id=0a27a9bf&"
import script from "./reactivo-categorizacion-reload-respuestas.vue?vue&type=script&lang=js&"
export * from "./reactivo-categorizacion-reload-respuestas.vue?vue&type=script&lang=js&"
import style0 from "./reactivo-categorizacion-reload-respuestas.vue?vue&type=style&index=0&id=0a27a9bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports